import { useEffect, useRef } from "react";

export function useInterval(callback, delay) {
    
    const savedCallback = useRef();

    let id = null;

    useEffect(() => {
        savedCallback.current = callback;
    });

    useEffect(() => {
        function tick() {
            savedCallback.current();
        }

        id = setInterval(tick, delay);
        
        return () => clearInterval(id);

    }, [delay]);

    return id;
}